import React from 'react';
import { FileUpload } from '@insurancemenu/imenu-components-lib';
import { AcceptedFiles } from '@insurancemenu/imenu-components-lib/dist/types/FileUpload';
import { UPLOAD_FILE_TYPES } from '@insurancemenu/imenu-components-lib/dist/components/FileUpload';
import { observer } from 'mobx-react-lite';
import { useChooseTheWayPageStore } from 'store/pages/proposal-generation/chooseTheWayPageStore';
import ProposalGenerationStepHeader from '../../ProposalGenerationStepHeader';
import { SECOND_STEP_TEST_ID, FILE_UPLOAD_SECTION_TEST_ID, FILE_UPLOAD_COMPONENT_TEST_ID } from '../constants';
import { FileUploadWrapperStyled } from './styles';

const SecondStep: React.FC = observer(() => {
  const { secondStepController } = useChooseTheWayPageStore();

  const handleFileChange = (files: AcceptedFiles): void => {
    secondStepController.setUploadedFile(files);
  };

  return (
    <section data-test-id={SECOND_STEP_TEST_ID}>
      <ProposalGenerationStepHeader
        title="Upload Your Custom Proposal File"
        info="Upload a single file in one of the supported formats: PDF or Excel (XLSX, XLS)."
      />
      <FileUploadWrapperStyled data-test-id={FILE_UPLOAD_SECTION_TEST_ID}>
        <FileUpload
          fileMimeTypes={[UPLOAD_FILE_TYPES.pdf, UPLOAD_FILE_TYPES.xlsx, UPLOAD_FILE_TYPES.xls]}
          messageForRejectedFiles="Please upload only PDF, Excel (XLSX, XLS) files"
          allowMultipleFiles={false}
          shouldBeReset={false}
          onChange={handleFileChange}
          data-test-id={FILE_UPLOAD_COMPONENT_TEST_ID}
        />
      </FileUploadWrapperStyled>
    </section>
  );
});

export default SecondStep;
